import io from 'socket.io-client';
import feathers from '@feathersjs/client';

import getServiceName from './getServiceName';
import { API_HOST } from '../config';

const API_URL: string = API_HOST;

export const socket = io(API_URL, {
  transports: ['websocket', 'polling'],
});
const client = feathers();

client.configure(feathers.socketio(socket, { timeout: 15000 }));
client.configure(feathers.authentication({
  path: getServiceName('auth'),
}));

export default client;
